import { getOSM, KPI_W, KPI_S, KPI_L } from '../OverworldAnimation.js';
import { TRAINER_CARD, POKEMON, POKEDEX, BAG, SAVE, OPTIONS_MENU } from '../constants.js';

export default class PauseMenu {
    constructor() {
        this.options = ['Pokedex', 'Pokemon', 'Bag', 'Trainer', 'Save', 'Options'];
        this.currentOption = 0;
    }

    increaseVerticalOption() {
        if (this.currentOption === this.options.length - 1) {
            this.currentOption = 0;
        } else {
            this.currentOption += 1;
        }
    }

    decreaseVerticalOption() {
        if (this.currentOption === 0) {
            this.currentOption = this.options.length - 1;
        } else {
            this.currentOption -= 1;
        }
    }

    getOptions() {
        this.options = ['Pokedex', 'Pokemon', 'Bag', getOSM().player.name, 'Save', 'Options'];
        return this.options;
    }

    getStateForCurrentOption() {
        switch (this.currentOption) {
            case 0:
                return POKEDEX;
            case 1:
                return POKEMON;
            case 2:
                return BAG;
            case 3:
                return TRAINER_CARD;
            case 4:
                return SAVE;
            case 5:
                return OPTIONS_MENU;
            default:
                return OPTIONS_MENU;
        }
    }

    manageInputs() {
        if (KPI_W) {
            this.decreaseVerticalOption();
        }
        if (KPI_S) {
            this.increaseVerticalOption();
        }
        return KPI_L;
    }
}
